import checkout from "./checkout.json";
export default {
  checkout
};
//# sourceMappingURL=index.mjs.map